import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import { Dropdown, DropdownPosition, DropdownDirection, KebabToggle, DropdownItem, DropdownSeparator } from '@patternfly/react-core';
export var ActionsColumn =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActionsColumn, _React$Component);

  function ActionsColumn(props) {
    var _this;

    _classCallCheck(this, ActionsColumn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionsColumn).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onToggle", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (event, onClick) {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          extraData = _this$props.extraData;
      event.preventDefault(); // tslint:disable-next-line:no-unused-expression

      onClick && onClick(event, extraData && extraData.rowIndex, rowData, extraData);

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(ActionsColumn, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          items = _this$props2.items,
          children = _this$props2.children,
          dropdownPosition = _this$props2.dropdownPosition,
          dropdownDirection = _this$props2.dropdownDirection,
          isDisabled = _this$props2.isDisabled;
      return React.createElement(React.Fragment, null, React.createElement(Dropdown, {
        toggle: React.createElement(KebabToggle, {
          isDisabled: isDisabled,
          onToggle: this.onToggle
        }),
        position: dropdownPosition,
        direction: dropdownDirection,
        isOpen: isOpen,
        dropdownItems: items.map(function (_ref, key) {
          var title = _ref.title,
              itemKey = _ref.itemKey,
              _onClick = _ref.onClick,
              isSeparator = _ref.isSeparator,
              props = _objectWithoutProperties(_ref, ["title", "itemKey", "onClick", "isSeparator"]);

          return isSeparator ? React.createElement(DropdownSeparator, _extends({}, props, {
            key: itemKey || key,
            "data-key": itemKey || key
          })) : React.createElement(DropdownItem, _extends({
            onClick: function onClick(event) {
              return _this2.onSelect(event, _onClick);
            }
          }, props, {
            key: itemKey || key,
            "data-key": itemKey || key
          }), title);
        }),
        isPlain: true
      }), children);
    }
  }]);

  return ActionsColumn;
}(React.Component);

_defineProperty(ActionsColumn, "propTypes", {
  children: _pt.node,
  items: _pt.arrayOf(_pt.any),
  isDisabled: _pt.bool,
  dropdownPosition: _pt.any,
  dropdownDirection: _pt.any,
  rowData: _pt.any,
  extraData: _pt.any
});

_defineProperty(ActionsColumn, "defaultProps", {
  children: null,
  items: [],
  dropdownPosition: DropdownPosition.right,
  dropdownDirection: DropdownDirection.down,
  rowData: {},
  extraData: {}
});